import React, { useCallback, useRef } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'
import { motion } from 'framer-motion'

import { ReactComponent as LiveChatSvg } from 'shared/img/live-chat.svg'

import { getIsLiveChatDisabled } from 'shared/utils/agentSocialLinks'
import { openChat } from 'shared/utils/liveChat'

import { selectAgentSocialLinks, selectIsUserAuthenticated } from 'features/auth/selectors'

import './LiveChatButton.scss'

const b = block('live-chat-button')

export const LiveChatButton = () => {
  const dragAreaRef = useRef<HTMLDivElement>(null)
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const agentSocialLinks = useSelector(selectAgentSocialLinks, shallowEqual)

  const handleClick = useCallback(() => {
    openChat()
  }, [])

  if (getIsLiveChatDisabled(isAuth, agentSocialLinks)) return null

  return (
    <div ref={dragAreaRef} className={b('drag-area')}>
      <motion.div
        className={b('wrapper').mix('custom-chat-button').toString()}
        drag="y"
        dragElastic={0.2}
        dragConstraints={dragAreaRef}
        onClick={handleClick}>
        <LiveChatSvg />
      </motion.div>
    </div>
  )
}
